<template>
  <div v-if="busy">
    <ProgressSpinner />
  </div>

  <div v-else-if="newUser">
    <div class="container">
      <div class="sign-container">
        <div class="sign-frame">
          <div class="sign-side blue">
            <img :src="this.baseURL + '/mascots/main.svg'" alt="DS Mascot" />
            <h1 v-html="$t('welcome_to_ds')"></h1>

            <h3 v-html="$t('make_planning')"></h3>

            <div class="quote">
              <p v-html="$t('default_quote')"></p>
            </div>
          </div>

          <div class="sign-side">
            <div class="form">
              <h2 class="mb-6 title is-3" style="font-weight: normal;">
                <div v-html="$t('Wizard.sign_in_title')"></div>
              </h2>

              <div class="field">
                <label class="required-label" for="email">{{ $t("Form.email") }}</label>
                <InputText id="email" placeholder="name@company.com" type="email" v-model="email" />
              </div>

              <Button
                :disabled="!this.validateEmail(email) || busy"
                class="btn-submit"
                @click="signUp"
                :label="$t('sign_up')"
              />
              <div v-if="!jpLocale">
                <div class="or-divider mt-2 mb-1">Or</div>

                <div class="button se-button" @click="startSportsEngineAuth" v-if="!jpLocale">
                  Sign up with
                  <img src="/se_logo_full.png" alt="SportsEngine" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-else id="wizard">
    <div v-show="debugging">
      <div>
        <h1>{{ $t("AppMenu.divisions") }}</h1>
        <div v-for="d in divisions" :key="d.id">
          <small> {{ d }} </small> <br /><br />
        </div>
        <br /><br />
      </div>
      <div>
        <h1>{{ $t("Team.teams") }}</h1>
        <div v-for="d in teams" :key="d.id">
          <small> {{ d }} </small> <br /><br />
        </div>
        <br /><br />
      </div>

      <div>
        <h1>{{ $t("AppMenu.venues") }}</h1>
        <div v-for="d in venues" :key="d.id">
          <small> {{ d }} </small> <br /><br />
        </div>
        <br /><br />
      </div>
    </div>
    <div id="topContainer" class="p-grid p-ai-center vertical-container" v-show="step != 15">
      <div v-if="!isProduction" class="p-col-12">
        <Button class="p-button-sm" style="margin: 0px 2px; background: green" :label="R" @click="refresh" />
        <Button class="p-button-sm" style="margin: 0px 2px; background: red" :label="step.toString()" @click="next" />
        <Button
          :class="{ 'p-button-outlined': i != step }"
          class="p-button-sm"
          style="margin: 0px 2px"
          v-for="i in 20"
          :key="i"
          :label="i.toString()"
          @click="step = i"
        />
      </div>
      <div class="p-col-2 p-text-center">
        <Button v-if="!isLoading && (loggedIn || step > 0)" id="bb" @click="back" class="p-button-text dsColor p-ml-5">
          <i class="pi pi-arrow-left" style="font-size: 2em"></i>
        </Button>
        <Button v-if="!isProduction" @click="debugging = !debugging" class="p-button-text dsColor p-ml-5">
          DB
        </Button>
      </div>
      <div class="p-col-8">
        <ProgressBar
          v-if="!isLoading"
          :value="progress"
          :showValue="false"
          style="height: 0.5em; width: 90%; max-width: 600px; margin: 0 auto"
        />
      </div>
      <div class="p-col-2 p-text-center" v-if="loggedIn">
        <Button
          :label="$t('exit')"
          @click="confirmCancel"
          style="font-size: 1.5em"
          v-if="step != 17 && !reviewTimeslots"
          class="p-button-md p-button-text dsColor"
        />
      </div>
      <div class="p-col-2 p-text-center" v-else-if="!this.division_id">
        <Button
          :label="$t('GameTable.column.finish')"
          @click="finish"
          style="font-size: 1.5em"
          v-if="step != 11"
          class="p-button-md p-button-text dsColor"
        />
      </div>
      <div class="p-col-2 p-text-center" v-else-if="this.division_id">
        <Button
          :label="$t('Button.cancel')"
          @click="confirmCancel"
          style="font-size: 1.5em"
          v-if="step != 17"
          class="p-button-md p-button-text dsColor"
        />
      </div>
    </div>
    <!-- ffff -->
    <div v-if="reviewTimeslots" class="p-grid">
      <div class="p-col-12">
        <span class="title is-3"
          >{{
            $t("review-timeslots-finaltimeslots-length-existingtimeslots-length", [
              finalTimeslots.length + existingTimeslots.length,
            ])
          }}
        </span>
        <div>
          {{ $t("remove-any-timeslots-that-you-dont-want-a-itemname-single-scheduled-on", [itemName.single]) }}
        </div>
      </div>
      <div class="p-col-12 p-mt-2 p-mb-3">
        <Button class="p-button-lg dsButton" :label="$t('Button.continue')" @click="next" />
      </div>
      <div v-if="existingTimeslots.length > 0" class="p-col-12">
        <div class="title is-5 p-mt-2">
          {{ $t("existing-timeslots-this-existingtimeslots-length", [this.existingTimeslots.length]) }}<br />
          <Button
            class="p-button-sm p-button-text"
            :label="$t('delete-all-existing-timeslots')"
            @click="startDeleteExisting"
          />
        </div>
        <table>
          <tr>
            <th class="reviewHeader"></th>
            <th class="reviewHeader">{{ $t("GameTable.column.date") }}</th>
            <th class="reviewHeader">{{ $t("GameTable.column.time") }}</th>
            <th class="reviewHeader">{{ $t("GameTable.column.finish") }}</th>
            <th class="reviewHeader">{{ $t("GameTable.column.venue") }}</th>
            <th class="reviewHeader">{{ $t("field") }}</th>
          </tr>
          <tr v-for="t in existingTimeslots" :key="t.id" style="height: 2em">
            <td class="reviewHeader">
              <font-awesome-icon
                v-tooltip="'Delete Timeslot'"
                class="cursorpointer"
                :icon="['fal', 'trash-alt']"
                style="color: darkred; font-size: 1.5em"
                @click="removeReal(t)"
              />
            </td>
            <td class="reviewHeader">
              <span>{{ t.start | moment("dddd, MMMM Do YYYY") }}</span>
            </td>
            <td class="reviewHeader">
              <span>{{ t.start | moment("h:mm a") }}</span>
            </td>
            <td class="reviewHeader">
              <span>{{ t.finish | moment("h:mm a") }}</span>
            </td>
            <td class="reviewHeader">{{ t.venue.name }}</td>
            <td class="reviewHeader">{{ t.surface.name }}</td>
          </tr>
        </table>

        <div class="title is-5 p-mt-5">
          {{ $t("resulting-timeslots-this-finaltimeslots-length", [this.finalTimeslots.length]) }}
        </div>
      </div>
      <table v-if="finalTimeslots.length">
        <tr>
          <th class="reviewHeader"></th>
          <th class="reviewHeader">{{ $t("GameTable.column.date") }}</th>
          <th class="reviewHeader">{{ $t("GameTable.column.day") }}</th>
          <th class="reviewHeader">{{ $t("GameTable.column.start") }}</th>
          <th class="reviewHeader">{{ $t("GameTable.column.finish") }}</th>
          <th class="reviewHeader">{{ $t("GameTable.column.venue") }}</th>
          <th class="reviewHeader">{{ $t("field") }}</th>
        </tr>
        <tr v-for="t in finalTimeslots" :key="t.id" style="height: 2em">
          <td class="reviewHeader">
            <font-awesome-icon
              v-tooltip="'Delete Timeslot'"
              class="cursorpointer"
              :icon="['fal', 'trash-alt']"
              style="color: darkred; font-size: 1.5em"
              @click="remove(t)"
            />
          </td>
          <td class="reviewHeader">{{ t.start_date }}</td>
          <td class="reviewHeader">{{ t.weekday }}</td>
          <td class="reviewHeader">{{ t.start_time }}</td>
          <td class="reviewHeader">{{ t.end_time }}</td>
          <td class="reviewHeader">{{ t.venue_name }}</td>
          <td class="reviewHeader">{{ t.surface_name }}</td>
        </tr>
      </table>

      <div class="p-col-12" v-if="finalTimeslots.length > 50">
        <Button class="p-button-lg dsButton" :label="$t('Button.continue')" @click="next" />
      </div>
    </div>
    <div v-if="step == 15" v-show="!reviewTimeslots" class="p-grid" style="padding-top: 0; padding-bottom: 0;">
      <div class="p-col-12"><Cal :calinfo="{ divisions: divisions }" /></div>
    </div>
    <div v-else class="wizardCenteredContainer">
      <div v-if="isLoading">
        <div class="p-mb-3">
          <p class="header">
            <span v-if="shouldSchedule && divisions.length == 1"> {{ $t("were-creating-your-schedule") }}</span>
            <span v-else-if="shouldSchedule && divisions.length > 1"> {{ $t("were-creating-your-schedules") }}</span>
            <span v-else> {{ $t("were-creating-your-league") }}</span>
          </p>
          <p class="subheader">{{ $t("now-might-be-a-good-time-for-a-water-break") }}</p>
          <br /><br />
          <img class="centeredGif" :src="`${baseURL}/diamond.gif`" />
        </div>
      </div>
      <div v-else>
        <div v-if="step == 12" class="p-mb-3">
          <p class="header">{{ $t("what-type-of-schedule") }}</p>
          <div class="p-mt-3">
            <Button
              @click="isPractice = false"
              class="p-button-lg"
              :class="{ 'p-button-outlined': this.isPractice == true }"
              :label="$t('round-robin')"
            />
            &nbsp;&nbsp;
            <Button
              @click="isPractice = true"
              class="p-button-lg"
              :class="{ 'p-button-outlined': this.isPractice == false }"
              :label="$t('item_string.practice')"
            />
          </div>
        </div>
        <div class="p-mb-3 p-mt-5">
          <p class="header" v-html="stepData ? $t(stepData.header) : ''" />
          <p class="subheader" style="max-width: 800px" v-html="$t(stepData.subheader)" />
        </div>
        <!-- Select Sport -->
        <div v-if="step == 0">
          <div class="p-grid" style="width: 100%; p-mt-2">
            <div v-for="d in sports" :key="d.name" class="p-my-2 p-col-4 p-xs-12">
              <div class="bigWhiteButton p-mx-2 expand" @click="setSport(d.name)">
                <img :src="d.image" />
                <div class="bold">{{ d.name }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Select method -->
        <div v-if="step == 1">
          <div class="p-d-flex p-flex-column p-flex-md-row p-jc-center">
            <div class="p-mb-2 p-mr-3" v-if="!jpLocale">
              <div class="bigButton expand" @click="startSportsEngineAuth">
                <img class="centeredGif" :src="`${baseURL}/sportsEngine_icon-logo-white.svg`" />
                {{ $t("bigButton.import_from_se") }}
              </div>
            </div>
            <div class="p-mb-2 p-mr-3">
              <div class="bigButton expand" @click="next" :label="$t('start-from-scratch')">
                <font-awesome-icon class="cursorpointer" :icon="['fal', 'calendar']" /><br />
                {{ $t("bigButton.start_from_scratch") }}
              </div>
            </div>

            <div class="p-mb-2 p-mr-3">
              <div class="bigButton expand" @click="openCSV">
                <font-awesome-icon class="cursorpointer" :icon="['fal', 'arrow-to-top']" /><br />
                {{ $t("bigButton.upload_csv") }}
              </div>
            </div>
          </div>
        </div>

        <!-- League Name -->
        <div v-if="step == 2" class="p-grid">
          <div class="p-col-6">
            <label class="wizardLabel" for="leaguename">{{ $t("Wizard.wizardLabel.leaguename") }}</label
            ><br />
            <InputText
              class="p-mt-1 leagueBox"
              id="leaguename"
              @keyup.enter="tryNext"
              :placeholder="$t('Wizard.wizardPlaceholder.leaguename')"
              v-model.trim="leagueName"
            />
          </div>
          <div class="p-col-6">
            <label class="wizardLabel" for="seasonname">{{ $t("Wizard.wizardLabel.seasonname") }}</label
            ><br />
            <InputText
              class="p-mt-1 leagueBox"
              id="seasonname"
              @keyup.enter="tryNext"
              :placeholder="$t('Wizard.wizardPlaceholder.seasonname')"
              v-model.trim="seasonName"
            />
          </div>
        </div>

        <!-- How many divisions? -->
        <div v-if="step == 4">
          <Button
            :class="{ 'p-button-outlined': i != divisionCount }"
            class="p-button-sm"
            style="margin: 0px 2px"
            v-for="i in numCount"
            :key="i"
            :label="i.toString()"
            @click="setDivisions(i)"
          />
          <div v-if="numCount == 10" class="p-mt-2">
            <Button class="p-button-text p-button-sm" @click="numCount = 30">
              {{ $t("Button.need_more_than_10") }}</Button
            >
          </div>
        </div>
        <div v-if="step == 5">
          <Button class="p-button-text p-button-sm" @click="numCount = 30">
            {{ $t("Button.need_more_than_10") }}
          </Button>
          <div v-for="(d, i) in divisions" :key="d.id" class="p-my-2">
            <span>{{ d.name }}</span> &nbsp;
            <Button
              :class="{ 'p-button-outlined': j != d.teamCount }"
              class="p-button-sm"
              style="margin: 0px 2px"
              v-for="j in numCount"
              :key="j"
              :label="j.toString()"
              @click="setTeams(i, j)"
            />
          </div>
        </div>
        <div v-if="step == 6">
          <div class="p-d-flex p-flex-wrap p-jc-evenly">
            <div v-for="d in divisions" :key="d.id" class="p-my-2">
              <div
                class="p-d-flex p-flex-column p-mx-2"
                style="border-radius: 5px; padding: 20px; margin: 0px 15px"
                :style="{ border: '4px solid ' + d.color }"
              >
                <div class="p-grid" style="width: 450px">
                  <div class="p-col-9">
                    <div class="bold">
                      {{ $t("Form.division.name") }}
                      <span
                        class="colorBall"
                        v-tooltip="'Click to edit division color'"
                        @click="d.showColor = true"
                        style="height: 1em; width: 1em; cursor: pointer"
                        v-bind:style="{ background: d.color || '#FFFFFF' }"
                      />
                    </div>
                    <InputText class="p-my-1" type="text" v-model.trim="d.name" />
                  </div>
                  <div class="p-col-3 p-text-left">
                    <div class="bold" style="margin-left: -20px">{{ $t("Form.shared.abbr") }}</div>
                    <div>
                      <InputText
                        style="width: 80px"
                        class="p-my-1"
                        type="text"
                        maxlength="4"
                        v-model.trim="d.shortcode"
                      />
                    </div>
                  </div>
                </div>
                <div v-if="d.showColor">
                  <Picker
                    :value="d.color"
                    @input="
                      color => {
                        d.color = color.hex;
                        d.showColor = false;
                      }
                    "
                    :palette="primaryPallette"
                  />
                </div>
                <div class="p-grid" style="width: 450px">
                  <div class="p-col-9">
                    <div class="p-mt-3 bold">{{ $t("Form.team.name") }}</div>
                    <div v-for="t in d.teams" :key="t.id">
                      <InputText style="width: 250px" class="p-my-1" type="text" v-model.trim="t.name" />
                    </div>
                  </div>
                  <div class="p-col-3 p-text-left">
                    <div class="p-mt-3 bold" style="margin-left: -20px">{{ $t("Form.shared.abbr") }}</div>
                    <div v-for="t in d.teams" :key="t.id">
                      <InputText
                        style="width: 80px"
                        class="p-my-1"
                        type="text"
                        maxlength="4"
                        v-model.trim="t.shortcode"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="step == 7">
          <div v-if="currentVenue.gaddress" class="p-mb-1">
            <div id="map"></div>
            <div class="title is-4 p-mt-3">{{ currentVenue.name }}</div>
            <div>{{ currentVenue.address.formatted }}</div>
            {{ $t("Wizard.not_right") }} <a @click="resetVenue"> {{ $t("Wizard.clear_venue") }} </a> <br />
          </div>
          <div v-else>
            <vue-google-autocomplete
              id="google_map"
              ref="address"
              classname="input"
              types="establishment"
              autofocus="true"
              :placeholder="$t('Form.shared.start_typing')"
              v-on:placechanged="getAddressData"
            />
            <p class="p-mt-3">
              <a @click="manualVenue = true"> {{ $t("Wizard.add_venue_manually") }} </a>
            </p>
          </div>
        </div>

        <!-- How many surfaces? -->
        <div v-if="step == 8">
          <Button
            :class="{ 'p-button-outlined': i != surfaceCount }"
            class="p-button-sm"
            style="margin: 0px 2px"
            v-for="i in 10"
            :key="i"
            :label="i.toString()"
            @click="setFields(i)"
          />
          <div v-if="numCount == 10" class="p-mt-2">
            <Button class="p-button-text p-button-sm" @click="numCount = 20">
              {{ $t("Button.need_more_than_10") }}</Button
            >
          </div>
          <div class="p-mt-3 p-mb-1">{{ $t("Form.fields.prompt_to_enter_name", { surface: surfaceName.single }) }}</div>
          <div v-for="t in currentVenue.surfaces" :key="t.id">
            <InputText class="p-my-1" type="text" v-model.trim="t.name" :key="t.id" />
          </div>
        </div>

        <div v-if="step == 9">
          <div>
            <div class="p-mt-3">
              <Button
                @click="allTeams = true"
                class="p-button-lg"
                :class="{ 'p-button-outlined': this.allTeams == false }"
                :label="$t('Button.all_teams')"
              />
              &nbsp; &nbsp;
              <Button
                @click="allTeams = false"
                class="p-button-lg"
                :class="{ 'p-button-outlined': this.allTeams == true }"
                :label="$t('Button.some_teams')"
              />
            </div>
          </div>
          <div v-if="!allTeams"><br />{{ $t("choose-home-team-leave-blank-for-all") }}</div>
          <div v-if="!allTeams" class="p-d-flex p-flex-wrap p-jc-evenly">
            <div v-for="d in divisions" :key="d.id" class="p-my-2">
              <div class="p-d-flex p-flex-column p-mx-2">
                <div class="bold p-my-2">{{ d.name }}</div>
                <div class="p-field-checkbox" v-for="t in d.teams" :key="t.id">
                  <Checkbox :value="t.id" v-model="someTeams" />
                  <label> {{ t.name }}</label>
                </div>
                <Button class="p-button-sm p-button-text" @click="toggleTeams(d)" :label="$t('toggle-all')" />
              </div>
            </div>
          </div>
        </div>

        <div v-if="step == 10">
          <div class="p-d-flex p-flex-column p-flex-md-row p-jc-center">
            <div class="p-mb-2 p-mr-2">
              <Button class="bigButton" @click="addAnotherVenue" :label="$t('Wizard.button.yes')" />
            </div>
            <div class="p-mb-2 p-mr-2">
              <Button class="bigButton" style="background: red" @click="next" :label="$t('Wizard.button.no')" />
            </div>
          </div>
        </div>

        <div v-if="step == 11">
          <div class="p-fluid p-formgrid p-grid" style="max-width: 600px; margin: 0 auto">
            <div v-if="!loggedIn && showSignIn" class="p-field p-col-12 ">
              <h1 class="title is-2">{{ $t("sign_in") }}</h1>
              <div class="p-field p-col-12 p-mt-3">
                <label for="firstname6">{{ $t("Account.email") }}</label>
                <InputText
                  autofocus="true"
                  id="firstname6"
                  v-model.trim="userInfo.email"
                  placeholder="$t('your-email-address')"
                  type="email"
                />
              </div>
              <div class="p-field p-col-12">
                <label for="lastname6">{{ $t("SignupWizard.password") }}</label>
                <InputText
                  id="lastname6"
                  v-model.trim="userInfo.password"
                  placeholder="$t('enter-password')"
                  type="password"
                />
              </div>
            </div>
            <div v-else-if="!loggedIn && !showSignIn" class="p-grid">
              <div class="p-col-12 p-text-centered">
                <h1 class="title is-2 p-text-center">{{ $t("league-set-up-complete") }}</h1>
                <p>{{ $t("create-an-free-account-to-create-your-schedules") }}</p>
                <br />
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="firstname6">{{ $t("PersonForm.first-name") }}</label>
                <InputText
                  autofocus="true"
                  id="firstname6"
                  v-model.trim="userInfo.first"
                  placeholder="$t('e-g-hank')"
                  type="text"
                />
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="lastname6">{{ $t("PersonForm.last-name") }}</label>
                <InputText id="lastname6" v-model.trim="userInfo.last" placeholder="$t('e-g-smith')" type="text" />
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="email">{{ $t("Account.email") }}</label>
                <InputText
                  id="email"
                  placeholder="$t('e-g-hank-smith-gmail-com')"
                  type="email"
                  v-model.trim="userInfo.email"
                />
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="password">{{ $t("SignupWizard.password") }}</label>
                <InputText
                  id="password"
                  placeholder="$t('SignupWizard.minimum_password')"
                  type="password"
                  v-model.trim="userInfo.password"
                />
              </div>
              <div class="p-field p-col-12 p-md-12">
                <label for="organization">{{ $t("organization-name") }}</label>
                <InputText
                  id="organization"
                  placeholder="$t('Wizard.wizardPlaceholder.leaguename')"
                  type="text"
                  v-model.trim="userInfo.organization"
                />
              </div>
            </div>
            <div v-else-if="loggedIn" class="p-col-12">
              <h1 class="title is-3">{{ $t("Wizard.loggedIn.title") }}</h1>
              <p class="subheader">{{ $t("Wizard.loggedIn.subheader1") }}</p>
              <p class="subheader">
                {{ $t("Wizard.loggedIn.subheader2") }}
              </p>
              <Button
                style="max-width: 300px; margin: 0 auto;"
                @click="newFinish(0)"
                :label="$t('Button.create_schedule')"
                class="p-button-lg dsButton p-mt-3"
              />
              <br /><br />
              <Button
                style="max-width: 300px; margin: 0 auto;"
                @click="newFinish(2)"
                :label="$t('Button.go_to_dashboard')"
                class="p-button-lg dsButton p-mt-3"
              />
            </div>
            <div class="p-col-12 p-mb-5" v-if="!loggedIn">
              <Button
                style="max-width: 300px; margin: 0 auto;"
                :disabled="!validSignInfo"
                @click="finish"
                :label="showSignIn ? $t('Button.sign_in_and_continue') : $t('Button.sign_up_and_continue')"
                class="p-button-lg dsButton p-mt-3"
              />
            </div>
            <div v-if="!loggedIn && !showSignIn" class="p-field p-col-12">
              {{ $t("Signup.has_account") }} <a @click="showSignIn = true">{{ $t("Signup.click_to_sign_in") }}</a>
            </div>
            <div v-else-if="showSignIn && !loggedIn" class="p-field p-col-12">
              {{ $t("Signin.do_not_have_account") }}
              <a @click="showSignIn = false">{{ $t("Signin.click_to_create") }}</a>
            </div>
          </div>
        </div>

        <div v-if="step == 12">
          <div class="p-d-flex p-flex-column p-flex-md-row p-jc-center">
            <div class="p-mb-2 p-mr-2">
              <Button
                v-if="!isPractice"
                class="bigButton"
                v-tooltip="'Round is when each team plays every other team once'"
                @click="setStyle('rounds')"
                :label="$t('rounds-per-team')"
              />
            </div>
            <div class="p-mb-2 p-mr-2">
              <Button
                class="bigButton"
                @click="setStyle('week')"
                :label="
                  $t('capitalizefirstletter-itemname-plural-per-team-per-week', [
                    capitalizeFirstLetter(itemName.plural),
                  ])
                "
              />
            </div>
            <div class="p-mb-2 p-mr-2">
              <Button
                class="bigButton"
                @click="setStyle('season')"
                :label="
                  $t('capitalizefirstletter-itemname-plural-per-team-per-season', [
                    capitalizeFirstLetter(itemName.plural),
                  ])
                "
              />
            </div>
          </div>
        </div>

        <div v-if="step == 13">
          <div v-for="d in divisions" :key="d.id" class="p-my-3">
            <h2 class="title is-5">{{ d.name }}</h2>
            <Button icon="pi pi-minus" class="p-button-rounded p-button-outlined" @click="adjustStyle(false, d.id)" />
            <InputNumber :min="1" v-model="d.styleCount" class="p-mx-3" />
            <Button icon="pi pi-plus" class="p-button-rounded p-button-outlined" @click="adjustStyle(true, d.id)" />
          </div>
        </div>
        <div v-if="step == 16">
          <div class="p-d-flex p-flex-wrap p-jc-evenly">
            <div v-for="d in divisions" :key="d.id" class="p-my-2">
              <div class="p-d-flex p-flex-column p-mx-2 p-x-5">
                <div class="bold p-my-2">{{ d.name }}</div>
                <div class="p-field-checkbox" style="font-size: 1.5em">
                  <Checkbox :binary="true" v-model="d.shouldSchedule" />
                  <label> {{ $t("Button.create_schedule") }} </label>
                </div>
                <div v-if="d.shouldSchedule">
                  <div class="p-mt-3 constraintBox">
                    <label for="horizontal">{{ $t("max-games-day") }}</label>
                    <br />
                    <a @click="d.config.max_games_day = 1" v-show="d.config.max_games_day == 0">
                      {{ $t("Button.add-constraint") }}
                    </a>
                    <InputNumber
                      v-show="d.config.max_games_day > 0"
                      class="configNumber p-mt-1"
                      v-model="d.config.max_games_day"
                      showButtons
                      buttonLayout="horizontal"
                      :step="1"
                      :min="0"
                      :max="10"
                      @input="configUpdate(d)"
                      incrementButtonIcon="pi pi-plus"
                      decrementButtonIcon="pi pi-minus"
                    />
                  </div>
                  <div class="p-mt-3 constraintBox">
                    <label for="horizontal">{{ $t("max-games-week") }}</label>
                    <br />
                    <a
                      @click="d.config.max_games_week = Math.max(1, d.config.max_games_day)"
                      v-show="d.config.max_games_week == 0"
                    >
                      {{ $t("Button.add-constraint") }}
                    </a>
                    <InputNumber
                      v-show="d.config.max_games_week > 0"
                      class="configNumber p-mt-1"
                      v-model="d.config.max_games_week"
                      showButtons
                      buttonLayout="horizontal"
                      :step="1"
                      :min="0"
                      :max="70"
                      @input="configUpdate(d)"
                      incrementButtonIcon="pi pi-plus"
                      decrementButtonIcon="pi pi-minus"
                    />
                  </div>
                  <div class="p-mt-3 constraintBox">
                    <label
                      for="horizontal"
                      v-tooltip="
                        'How many minutes should pass before a team can play again on the same day? Enter 0 to allow for back to back games.'
                      "
                      >{{ $t("minutes-between-games") }}</label
                    >
                    <br />
                    <a
                      v-if="d.config.max_games_day != 1 && d.config.max_games_day != 1"
                      @click="d.config.min_minutes_rest = 60"
                      v-show="d.config.min_minutes_rest == 0"
                    >
                      {{ $t("Button.add-constraint") }}
                    </a>
                    <i v-else> {{ $t("not-available") }} </i>
                    <InputNumber
                      v-show="d.config.min_minutes_rest > 0"
                      :disabled="d.config.next_game_offset != 0 || d.config.max_games_day <= 1"
                      class="configNumber p-mt-1"
                      v-model="d.config.min_minutes_rest"
                      showButtons
                      buttonLayout="horizontal"
                      :step="15"
                      :min="0"
                      :max="1440"
                      @input="configUpdate(d)"
                      incrementButtonIcon="pi pi-plus"
                      decrementButtonIcon="pi pi-minus"
                    />
                  </div>
                  <div class="p-mt-3 constraintBox">
                    <label
                      for="horizontal"
                      v-tooltip="
                        'How many days should pass before a team can play again? Enter 0 to allow for games on consecutive days.'
                      "
                      >{{ $t("days-between-games") }}</label
                    >
                    <br />
                    <a
                      v-if="d.config.max_games_week != 1 && d.config.max_games_day < 2"
                      v-show="d.config.next_game_offset == 0"
                      @click="d.config.next_game_offset = 1"
                    >
                      {{ $t("Button.add-constraint") }}
                    </a>

                    <i v-else> {{ $t("not-available") }}</i>
                    <InputNumber
                      v-show="d.config.next_game_offset > 0"
                      class="configNumber p-mt-1"
                      :disabled="d.config.max_games_day != 1"
                      v-model="d.config.next_game_offset"
                      showButtons
                      buttonLayout="horizontal"
                      :step="1"
                      :min="0"
                      :max="30"
                      @input="configUpdate(d)"
                      incrementButtonIcon="pi pi-plus"
                      decrementButtonIcon="pi pi-minus"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="step == 17">
          <div class="p-d-flex p-jc-center mediumFormContainer">
            <div class="p-fluid p-formgrid p-grid">
              <div v-if="!loggedIn && showSignIn" class="p-field p-col-12 ">
                <div>
                  {{ $t("Signin.do_not_have_account") }}
                  <a @click="showSignIn = false">{{ $t("Signin.click_to_create") }} </a>
                </div>
                <div class="p-field p-col-12 p-mt-3">
                  <label for="firstname6">{{ $t("Account.email") }}</label>
                  <InputText
                    autofocus="true"
                    id="firstname6"
                    v-model.trim="userInfo.email"
                    placeholder="$t('your-email-address')"
                    type="email"
                  />
                </div>
                <div class="p-field p-col-12">
                  <label for="lastname6">{{ $t("SignupWizard.password") }}</label>
                  <InputText
                    id="lastname6"
                    v-model.trim="userInfo.password"
                    placeholder="$t('enter-password')"
                    type="password"
                  />
                </div>
              </div>
              <div v-else-if="!loggedIn && !showSignIn" class="p-field p-col-12">
                {{ $t("Signup.has_account") }} <a @click="showSignIn = true">{{ $t("Signup.click_to_sign_in") }}</a>
              </div>
              <div v-if="!loggedIn && !showSignIn" class="p-grid">
                <div class="p-field p-col-12 p-md-6">
                  <label for="firstname6">{{ $t("PersonForm.first-name") }}</label>
                  <InputText
                    autofocus="true"
                    id="firstname6"
                    v-model.trim="userInfo.first"
                    placeholder="$t('e-g-hank')"
                    type="text"
                  />
                </div>
                <div class="p-field p-col-12 p-md-6">
                  <label for="lastname6">{{ $t("PersonForm.last-name") }}</label>
                  <InputText id="lastname6" v-model.trim="userInfo.last" placeholder="$t('e-g-smith')" type="text" />
                </div>
                <div class="p-field p-col-12 p-md-6">
                  <label for="email">{{ $t("Account.email") }}</label>
                  <InputText
                    id="email"
                    placeholder="$t('e-g-hank-smith-gmail-com')"
                    type="email"
                    v-model.trim="userInfo.email"
                  />
                </div>
                <div class="p-field p-col-12 p-md-6">
                  <label for="password">{{ $t("SignupWizard.password") }}</label>
                  <InputText
                    id="password"
                    placeholder="$t('SignupWizard.minimum_password')"
                    type="password"
                    v-model.trim="userInfo.password"
                  />
                </div>
                <div class="p-field p-col-12 p-md-12">
                  <label for="organization">{{ $t("organization-name") }}</label>
                  <InputText
                    id="organization"
                    placeholder="$t('Wizard.wizardPlaceholder.leaguename')"
                    type="text"
                    v-model.trim="userInfo.organization"
                  />
                </div>
              </div>
              <div class="p-col-12">
                <Button
                  style="max-width: 200px; margin: 0 auto;"
                  :disabled="busy || !stepData.canContinue || (this.showSignIn && (!validEmail || !validPassword))"
                  @click="finish"
                  :label="$t('GameTable.column.finish')"
                  class="p-button-lg dsButton p-mt-3"
                />
              </div>
            </div>
          </div>
        </div>
        <div>
          <Button
            v-if="stepData.showContinue"
            :disabled="!stepData.canContinue"
            @click="next"
            :label="$t('Button.continue')"
            class="p-button-lg dsButton p-mt-5"
          />
          <br />
          <Button
            v-if="stepData.showSkip"
            :label="$t('skip-this-step')"
            class="p-button-md p-button-text dsColor p-mt-3"
          />
          <br />
          <Button
            v-if="this.furthestStep > this.step + 1"
            @click="step = furthestStep"
            :label="$t('Button.skip_to_last_step')"
            class="p-button-md p-button-text dsColor p-mt-3"
          />
        </div>
      </div>
    </div>
    <Dialog
      :header="$t('apply-template-before-switching')"
      :visible.sync="templateDialog"
      :style="{ width: this.seasonDates.weeks > 8 ? '1200px' : '800px', maxWidth: '95%' }"
      :modal="true"
    >
      <div class="p-grid">
        <div class="p-col-12">
          {{
            $t(
              "you-have-pending-timeslots-that-have-been-templated-but-not-applied-yet-would-you-like-to-do-apply-before-continuing",
            )
          }}
        </div>
        <div class="p-col-12">
          <Button class="p-button-lg " @click="doTemplate" :label="$t('Wizard.button.yes')" />
          <br /><br />
          <Button
            class="p-button-lg p-button-danger"
            @click="continueWithoutTimeslots"
            :label="$t('Wizard.button.no')"
          />
          <br />
        </div>
      </div>
    </Dialog>

    <Dialog
      :header="$t('Wizard.signInPrompt.header')"
      :visible.sync="signInPrompt"
      :style="{ width: '600px' }"
      :modal="true"
    >
      <div class="p-my-3 p-grid">
        <div class="p-col-12">
          {{ $t("Wizard.signInPrompt.section") }}
        </div>
        <div class="p-col-12 p-mt-3">
          <Button :label="$t('sign_in')" class="p-button-lg" @click="doSignIn"> </Button>
          <br /><br />
          <a @click="signInPrompt = false">{{ $t("Wizard.signInPrompt.continue_without_sign_in") }}</a>
        </div>
      </div>
    </Dialog>
    <Dialog :header="$t('manage-timeslot')" :visible.sync="activeEvent" :style="{ width: '600px' }" :modal="true">
      <div v-if="activeEvent">
        {{ activeEvent.start | moment("dddd, MMMM Do YYYY") }} {{ activeEvent.start | moment("h:mm a") }} at
        {{ activeEvent.title }}
      </div>
      <div class="p-my-3 p-grid" v-if="activeEvent && activeEvent.extendedProps.existing">
        <div class="p-col-12">
          <Button
            @click="removeRealID(activeEvent.id)"
            class="p-button-lg p-button-danger"
            :label="$t('Button.delete')"
          />
        </div>
        <div class="p-col-12 p-mt-5">
          <Button @click="activeEvent = null" class="p-button-lg p-button-text" :label="$t('Button.cancel')" />
        </div>
      </div>
      <div class="p-my-3 p-grid" v-else>
        <div class="p-col-6">
          <Button @click="duplicateFakeslot(activeEvent)" class="p-button-lg" :label="$t('duplicate')" />
        </div>
        <div class="p-col-6">
          <Button
            @click="deleteFakeslot(activeEvent)"
            class="p-button-lg p-button-danger"
            :label="$t('Button.delete')"
          />
        </div>
        <div class="p-col-12 p-mt-5">
          <Button @click="activeEvent = null" class="p-button-lg p-button-text" :label="$t('Button.cancel')" />
        </div>
      </div>
    </Dialog>
    <Dialog :header="$t('more-timeslots-needed')" :visible.sync="showWarningDialog" :style="{ width: '600px' }" :modal="true">
      <div class="p-my-3">
        <p>
          {{
            $t(
              "each-itemname-single-needs-a-timeslot-you-can-continue-without-creating-timeslots-but-some-itemname-plural-may-not-be-scheduled",
              [itemName.single, itemName.plural],
            )
          }}
        </p>
        <br />
        <table
          style="
            width: 100%;
            max-width: 300px;
            margin: 0 auto;
            border-top: 1px solid black;
            font-size: 0.8em;
          "
        >
          <tr v-for="d in divisions" :key="d.id" class="timeslotRow">
            <td class="p-text-left" style="width: 50%" :style="{ color: getDivisionColor(d.id) }">
              {{ d.name }}
            </td>
            <td class="p-text-right bold" :style="getProgressColor(slotsAvailable(d.id), d.slotsNeeded)">
              {{ $t("slotsavailable-d-id-d-slotsneeded-slots-filled", [slotsAvailable(d.id), d.slotsNeeded]) }}
            </td>
            <hr />
          </tr>
        </table>

        <div class="p-mt-3">
          <Button
            @click="showWarningDialog = false"
            :label="$t('add-more-timeslots')"
            class="p-button-lg dsButton p-mt-5"
          />
          <br /><br />
          <Button
            :label="$t('continue-anyway')"
            @click="finishTimeslots"
            style="font-size: 1em"
            v-if="step != 17"
            class="p-button-sm p-button-text dsColor"
          />
        </div>
      </div>
    </Dialog>

    <Dialog :header="$t('should-we-create-schedules')" :visible.sync="showDecision" :style="{ width: '600px' }" :modal="true">
      <div class="p-my-3">
        <p>
          {{ $t("press") }} <strong>{{ $t("create-schedules") }}</strong>
          {{ $t("to-automatically-create-schedules-for-each-division-youve-entered") }}
          <br />
          <br />
          {{ $t("press") }} <strong>{{ $t("skip-scheduling") }}</strong>
          {{
            $t(
              "to-create-your-league-and-schedule-later-at-your-own-convenience-choose-this-if-you-have-constraints-to-add-or-coaches-to-enter",
            )
          }}
        </p>
        <div div v-if="divisions.length > 1" class="p-mt-3">
          <div>
            <strong>{{ $t("choose-divisions-to-schedule") }}</strong>
          </div>
          <div v-for="d in divisions" :key="d.id" class="p-text-left p-my-2" style="width: 200px; margin: 0 auto">
            <Checkbox :binary="true" v-model="d.shouldSchedule" />
            <label> {{ d.name }}</label>
          </div>
        </div>
        <div class="p-mt-3">
          <Button
            v-if="getScheduleLabel.count > 0"
            :label="getScheduleLabel.label"
            @click="doFinish(true)"
            class="p-button-lg dsButton p-mt-5"
          />
          <br /><br />
          <Button
            :label="$t('skip-scheduling')"
            @click="doFinish(false)"
            style="font-size: 1em"
            class="p-button-sm p-button-text dsColor"
          />
        </div>
      </div>
    </Dialog>

    <Dialog :header="$t('are-you-sure')" :visible.sync="finishDialog" :style="{ width: '600px' }" :modal="true">
      <div class="p-my-3">
        <p>
          {{ $t("youre-about-to-skip-the-setup-wizard") }} <br /><br />{{
            $t(
              "well-use-your-current-progress-but-youll-need-to-finish-creating-your-schedule-s-within-the-app-on-your-own",
            )
          }}
        </p>
        <div class="p-mt-3">
          <Button @click="finishDialog = false" :label="$t('keep-going')" class="p-button-lg dsButton p-mt-5" />
          <br /><br />
          <Button
            :label="$t('finish-anyway')"
            @click="finish"
            style="font-size: 1em"
            class="p-button-sm p-button-text dsColor"
          />
        </div>
      </div>
    </Dialog>

    <Dialog
      :header="$t('Wizard.manual_venue_form.header')"
      v-if="currentVenue.address"
      :visible.sync="manualVenue"
      :style="{ width: '600px' }"
      :modal="true"
    >
      <div v-if="!isProduction">
        {{ manualVenue }}
      </div>
      <p class="bold p-my-3">{{ $t("Wizard.manual_venue_form.venue_name") }}</p>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col">
          <InputText v-model.trim="currentVenue.name" autofocus="true" id="name" type="text" />
        </div>
      </div>
      <div class="p-fluid">
        <p class="bold p-my-3">{{ $t("Wizard.manual_venue_form.venue_details") }}</p>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="line_1">{{ $t("Wizard.manual_venue_form.address_line_1") }}</label>
            <InputText v-model.trim="currentVenue.address.line_1" id="line_1" type="text" />
          </div>
          <div class="p-field p-col">
            <label for="line_2">{{ $t("Wizard.manual_venue_form.address_line_2") }}</label>
            <InputText v-model.trim="currentVenue.address.line_2" id="line_2" type="text" />
          </div>
        </div>
      </div>

      <div class="p-fluid">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="city">{{ $t("Wizard.manual_venue_form.city") }} </label>
            <InputText v-model.trim="currentVenue.address.city" id="city" type="text" />
          </div>
          <div class="p-field p-col">
            <label for="state">{{ $t("Wizard.manual_venue_form.state") }}</label>
            <InputText v-model.trim="currentVenue.address.state" id="state" type="text" />
          </div>
        </div>
      </div>

      <div class="p-fluid">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="country">{{ $t("Wizard.manual_venue_form.country") }}</label>
            <InputText v-model.trim="currentVenue.address.country" id="country" type="text" />
          </div>
          <div class="p-field p-col">
            <label for="zip">{{ $t("Wizard.manual_venue_form.zip") }}</label>
            <InputText v-model.trim="currentVenue.address.zip" id="zip" type="text" />
          </div>
        </div>
      </div>
      <div class="p-fluid">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="latitude">{{ $t("Wizard.manual_venue_form.latitude") }}</label>
            <InputText v-model.trim="currentVenue.address.latitude" id="latitude" type="text" />
          </div>
          <div class="p-field p-col">
            <label for="longitude">{{ $t("Wizard.manual_venue_form.longitude") }}</label>
            <InputText v-model.trim="currentVenue.address.longitude" id="longitude" type="text" />
          </div>
        </div>
      </div>
      <div class="p-fluid">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col">
            <label for="phone_primary">{{ $t("Wizard.manual_venue_form.phone") }}</label>
            <InputText v-model.trim="currentVenue.address.phone_primary" id="phone_primary" type="text" />
          </div>
          <div class="p-field p-col">
            <label for="email_primary">{{ $t("Wizard.manual_venue_form.email") }}</label>
            <InputText v-model.trim="currentVenue.address.email_primary" id="email_primary" type="text" />
          </div>
        </div>
      </div>
      <div class="p-my-3">
        <Button
          :disabled="!currentVenue.name"
          @click="next"
          :label="$t('Button.save_venue')"
          class="p-button-lg dsButton p-mt-5"
        />
        <br /><br />
        <Button @click="manualVenue = false" :label="$t('Button.cancel')" class="p-button-sm p-button-text dsColor" />
      </div>
    </Dialog>
  </div>
</template>

<script>
import api from "@/api";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";

export default {
  components: { VueGoogleAutocomplete, FullCalendar },
  metaInfo: {
    link: [{ rel: "canonical", href: "https://app.cactusware.com/wizard" }],
  },
  data() {
    return {
      calInfo: { a: "b" },
      width: 1100,
      dayNames: [
        this.$t("sunday"),
        this.$t("monday"),
        this.$t("tuesday"),
        this.$t("wednesday"),
        "Thursday,",
        this.$t("friday"),
        this.$t("saturday"),
      ],
      debugging: false,
      templateMode: 0,
      templateSource: 0,
      signInPrompt: false,
      lengthOptions: [15, 30, 60, 90, this.$t("other_sports")],
      slotLength: 90,
      originals: [],
      templateDialog: false,
      calendarMode: 0,
      calendarDate: null,
      calendarView: "dayGridMonth",
      showSignIn: false,
      numCount: 10,
      activeEvent: null,
      map: null,
      allTeams: true,
      isPractice: false,
      reviewTimeslots: false,
      existingTimeslots: [],
      finalTimeslots: [],
      showDecision: false,
      shouldSchedule: true,
      finishDialog: false,
      someTeams: [],
      seasonName: "",
      furthestStep: 0,
      division_id: null,
      busy: true,
      manualVenue: false,
      showWarningDialog: false,
      noTooltip: false,
      isLoading: false,
      showTooltip: false,
      tooltipPosition: {
        x: 0,
        y: 0,
      },
      tooltipString: "",
      template: {
        venue: null,
        surface_ids: [],
        division_ids: [],
      },
      timeslots: [],
      totalTimeslotsNeeded: 0,
      userInfo: {
        first: "",
        last: "",
        organization: "",
        email: "",
        password: "",
      },
      style: "rounds",
      styleCount: 2,
      gameLength: 90,
      teams: [],
      surfaceCount: 2,
      venueIndex: 0,
      trigger: 0,
      step: 0,
      newUser: true,
      email: "",
      divisions: [
        {
          id: this.getRandomId(),
          name: this.$t("Division_with_num", { num: 1 }),
          shortcode: "D1",
          teamCount: 4,
          styleCount: 2,
          shouldSchedule: true,
          showColor: false,
          config: {
            min_minutes_rest: 0,
            next_game_offset: 0,
            max_games_day: 1,
            max_games_week: 0,
          },
          color: this.randomSecondaryHex(0),
          teams: [
            {
              id: this.getRandomId(),
              name: this.$t("Team_with_num", { num: "1A" }),
              shortcode: "T1A",
            },
            {
              id: this.getRandomId(),
              name: this.$t("Team_with_num", { num: "2A" }),
              shortcode: "T2A",
            },
            {
              id: this.getRandomId(),
              name: this.$t("Team_with_num", { num: "3A" }),
              shortcode: "T3A",
            },
            {
              id: this.getRandomId(),
              name: this.$t("Team_with_num", { num: "4A" }),
              shortcode: "T4A",
            },
          ],
        },
        {
          id: this.getRandomId(),
          name: this.$t("Division_with_num", { num: 2 }),
          shortcode: "D2",
          shouldSchedule: true,
          showColor: false,
          config: {
            min_minutes_rest: 0,
            next_game_offset: 0,
            max_games_day: 1,
            max_games_week: 0,
          },
          styleCount: 2,
          teamCount: 4,
          color: this.randomSecondaryHex(1),
          teams: [
            {
              id: this.getRandomId(),
              name: this.$t("Team_with_num", { num: "1B" }),
              shortcode: "T1B",
            },
            {
              id: this.getRandomId(),
              name: this.$t("Team_with_num", { num: "2B" }),
              shortcode: "T2B",
            },
            {
              id: this.getRandomId(),
              name: this.$t("Team_with_num", { num: "3B" }),
              shortcode: "T3B",
            },
            {
              id: this.getRandomId(),
              name: this.$t("Team_with_num", { num: "4B" }),
              shortcode: "T4B",
            },
          ],
        },
      ],
      venues: [
        {
          gaddress: null,
          address: {},
          color: this.randomSecondaryHex(),
        },
      ],
      sport: this.$t("soccer"),
      leagueName: this.$t("soccer-league"),
      divisionCount: 2,
      teamCount: 4,
      venueCount: 1,
      startDate: null,
      applyStart: null,
      applyEnd: null,
      endDate: null,
      sportOptions: [
        this.$t("baseball"),
        this.$t("basketball"),
        this.$t("football"),
        this.$t("ice-hockey"),
        this.$t("lacrosse"),
        this.$t("soccer"),
        this.$t("volleyball"),
        this.$t("other_sports"),
      ],
      calendarOptions: {
        headerToolbar: {
          left: "",
          right: "",
          center: "",
        },
        dayHeaderContent: this.getDayNames(),
        scrollTime: "08:00:00",
        scrollTimeReset: false,
        slotDuration: "00:15:00",
        expandRows: true,
        intiialDate: this.startDate,
        dayHeaderFormat: { weekday: "long" },
        allDaySlot: false,
        navLinks: false,
        plugins: [timeGridPlugin, dayGridPlugin, interactionPlugin],
        initialView: "timeGridWeek",
        height: "85vh",
        selectable: true,
        selectMinDistance: 50,
        dateClick: this.handleDateClick,
        select: this.handleSelect,
        events: this.timeslots,
        editable: true,
        eventDrop: this.handleEventDrop,
        eventMouseEnter: this.eventMouseEnter,
        eventMouseLeave: this.eventMouseLeave,
        eventResize: this.handleEventDrop,
        eventClick: this.handleEventClick,
        eventResizableFromStart: true,
        eventResizableFromEnd: true,
      },
    };
  },
  computed: {
    validSignInfo() {
      if (this.showSignIn) {
        console.log("ValidSign logged in: " + this.validEmail, this.validPassword);
        return this.validEmail && this.validPassword;
      } else {
        console.log("isValid: " + this.isValid);
        return this.isValid;
      }
    },
    potentialSlots() {
      this.applyStart = this.applyStart || this.$moment(this.startDate).format("YYYY-MM-DD");
      this.applyEnd = this.applyEnd || this.$moment(this.endDate).format("YYYY-MM-DD");
      var results = [];
      var bad = [];
      if (true || (this.templateDialog && this.applyStart && this.applyEnd)) {
        var as = this.$moment(new Date(this.applyStart));
        var ae = this.$moment(new Date(this.applyEnd));
        var originals = 0;
        this.originals.forEach(t => {
          if (!t.templated) {
            originals++;
            for (var i = 0; i <= this.seasonDates.weeks; i++) {
              var ts = this.$moment(t.start).add(i, "weeks");
              var te = this.$moment(t.end).add(i, "weeks");
              if (!ts.isBefore(as) && !te.isAfter(ae)) {
                var s = t.start;
                var e = t.end;
                var x = Object.assign({}, t);
                // console.log("Original Start: " + t.start);
                x.id = this.getRandomId();
                x.start = new Date(ts);
                x.start_date = this.$moment(s)
                  .add(i, "weeks")
                  .format("MM-DD-YY");
                x.end = new Date(te);
                x.id = this.getRandomId();
                x.templated = true;
                x.start_timestamp = new Date(this.$moment(s).add(i, "weeks")).getTime();

                var hasConflict = this.hasConflict(x);
                if (hasConflict) {
                  bad.push(x);
                } else {
                  results.push(x);
                }
              }
            }
          }
        });
      }
      return {
        originals: this.originals.length,
        existing: this.existingTimeslots.length + this.timeslots.length,
        pending: results.length,
        pendingSlots: this.existingTimeslots.concat(results),
        new: results.length,
        newslots: results,
        bad: bad,
        total: results.length - bad.length + this.timeslots.length + this.existingTimeslots.length,
      };
    },
    existingEvents() {
      var x = [];
      this.existingTimeslots.forEach(z => {
        x.push({
          id: z.id,
          venue_id: z.venue.id,
          existing: true,
          textColor: "white",
          title: z.surface.name + "@" + z.venue.name + this.$t("existing-timeslot"),
          backgroundColor: "black",
          borderColor: "black",
          editable: false,
          start: new Date(z.start),
          end: new Date(z.finish),
          divisions: [],
          surface_id: z.surface.id,
          surface_name: z.surface.name,
          venue_name: z.venue.name,
          start_date: this.$moment(z.start).format("MM-DD-YY"),
          start_time: this.$moment(z.start).format("LT"),
          end_time: this.$moment(z.finish).format("LT"),
          weekday: this.$moment(z.finish).format("dddd"),
          start_timestamp: new Date(z.start).getTime(),
        });
      });
      return x;
    },
    sports() {
      return [
        {
          name: this.$t("baseball"),
          image: this.baseURL + "/sports/baseball.svg",
        },
        { name: this.$t("basketball"), image: this.baseURL + "/sports/basketball.svg" },
        { name: this.$t("football"), image: this.baseURL + "/sports/football.svg" },
        { name: this.$t("soccer"), image: this.baseURL + "/sports/soccer.svg" },
        { name: this.$t("hockey"), image: this.baseURL + "/sports/puck.svg" },
        { name: this.$t("other_sports"), image: this.baseURL + "/sports/other.svg" },
      ];
    },
    getScheduleLabel() {
      var count = 0;
      this.divisions.forEach(d => {
        if (d.shouldSchedule) {
          count++;
        }
      });
      if (count == 1) {
        return { label: this.$t("create-1-schedule"), count: count };
      } else {
        return { label: this.$t("AppMenu.create_button") + count + this.$t("Schedule.schedules"), count: count };
      }
    },
    oldDates() {
      if (this.startDate) {
        return [];
      }
      var x = [];
      var today = this.$moment(new Date()).format("YYYY-MM-DD");
      x = [today];
      for (var i = 0; i < 90; i++) {
        var d = this.$moment(today)
          .add(i * -1, "days")
          .format("YYYY-MM-DD");
        x.push(d);
      }
      return x;
    },
    loggedIn() {
      return this.$store.getters.isAuthenticated;
    },
    timeslotsGood() {
      var good = true;
      if (this.slotsAvailable() + this.existingEvents.length >= this.totalTimeslotsNeeded) {
        return true;
      }
      if (this.slotsAvailable() >= this.totalTimeslotsNeeded) {
        this.divisions.forEach(d => {
          if (this.slotsAvailable(d.id) < d.slotsNeeded) {
            good = false;
          }
        });
        return good;
      }
      return false;
    },
    progress() {
      return (100 * (this.step + 1)) / 11;
    },
    validEmail() {
      return this.validateEmail(this.userInfo.email);
    },
    validPassword() {
      return this.userInfo.password.length > 6;
    },
    isValid() {
      if (this.isAuthenticated) {
        return true;
      }
      return (
        this.userInfo.first && this.userInfo.last && this.validEmail && this.validPassword && this.userInfo.organization
      );
    },
    currentVenue() {
      return this.venues[this.venueIndex];
    },
    surfaceName() {
      var fields = [this.$t("baseball"), this.$t("soccer"), this.$t("football"), this.$t("baseball")];
      var courts = [this.$t("basketball"), this.$t("tennis")];
      var sheets = [this.$t("hockey")];
      if (fields.indexOf(this.sport) > -1) {
        return {
          single: "field",
          plural: "fields",
        };
      } else if (courts.indexOf(this.sport) > -1) {
        return {
          single: "court",
          plural: "courts",
        };
      } else if (sheets.indexOf(this.sport) > -1) {
        return {
          single: this.$t("ice-sheet"),
          plural: this.$t("sheets-of-ice"),
        };
      } else {
        return {
          single: "surface",
          plural: this.$t("playing-surfaces"),
        };
      }
    },
    itemName() {
      var x = {
        single: "game",
        plural: "games",
      };
      if (this.isPractice) {
        x = {
          single: "practice",
          plural: "practices",
        };
      }
      return x;
    },
    stepData() {
      if (this.step < 0) {
        if (this.isAuthenticated) {
          this.goRouter("/");
          return;
        }
        this.step = 0;
      }
      var showSkip = false;
      var canContinue = false;
      var showContinue = true;
      var header = "";
      var subheader = "";
      if (this.trigger > 0) {
      }
      switch (this.step) {
        // Select Sport
        case 0:
          header = "Wizard.step0.header";
          subheader = "Wizard.step0.subheader";
          showContinue = false;
          canContinue = !!this.sport;
          break;
        // Select start method
        case 1:
          header = "Wizard.step1.header";
          subheader = "Wizard.step1.subheader";
          showContinue = false;
          break;
        case 2:
          header = "Wizard.step2.header";
          subheader = "Wizard.step2.subheader";
          canContinue = !!this.leagueName;
          canContinue = !!this.seasonName;
          break;
        case 4:
          header = "Wizard.step3.header";
          subheader = "Wizard.step3.subheader";
          canContinue = !!this.divisionCount;
          break;
        case 5:
          header = "Wizard.step5.header";
          subheader = "Wizard.step5.subheader";
          canContinue = !!this.teamCount;
          break;
        case 6:
          header = "Wizard.step6.header";
          subheader = "Wizard.step6.subheader";
          canContinue = !!this.teamCount;
          break;
        case 7:
          header = "Wizard.step7.header";
          subheader = "Wizard.step7.subheader";
          canContinue = this.currentVenue && !!this.currentVenue.name;
          break;
        case 8:
          this.setFields();
          header = this.$t("Wizard.step8.header", { venue: this.currentVenue.name, surface: this.surfaceName.plural });
          subheader = this.$t("Wizard.step8.subheader", { surface: this.surfaceName.plural });
          if (this.surfaceName.plural == this.$t("playing-surfaces")) {
            subheader = "Wizard.step8.playing_surfaces";
          }
          canContinue = !!this.surfaceCount;
          break;
        case 9:
          this.someTeams = this.currentVenue.teams;
          this.setFields();
          header = this.$t("Wizard.step9.header", { venue: this.currentVenue.name });
          subheader = "Wizard.step9.subheader";
          canContinue = true;
          break;
        case 10:
          this.teams = [];
          header = "Wizard.step10.header";
          subheader = "Wizard.step10.subheader";
          showContinue = false;
          break;
        case 11:
          canContinue = this.startDate && this.endDate;
          showContinue = false;
          break;
        case 12:
          header = "Wizard.step12.header";
          subheader = "Wizard.step12.subheader";
          showContinue = false;
          break;
        case 13:
          if (this.style == "rounds") {
            header = "Wizard.step13.header_round";
          } else if (this.style == "week") {
            header = this.$t("Wizard.step13.header_week", { items: this.itemName.plural });
          } else {
            header = this.$t("Wizard.step13.header_season", { items: this.itemName.plural });
          }
          subheader = "Wizard.step13.subheader";
          canContinue = true;
          break;
        case 14:
          header = "Wizard.step14.header";
          subheader = this.$t("Wizard.step14.subheader", { item: this.itemName.single });
          canContinue = true;
          this.adjustStyle();
          this.startDate = this.startDate || new Date();
          this.endDate =
            this.endDate ||
            this.$moment(this.startDate)
              .add(12, "weeks")
              .format("YYYY-MM-DD");
          this.calendarOptions.initialDate = this.startDate;
          this.calendarOptions.events = this.getCalTimeslots();
          break;
        case 15:
          console.log("StartDate: " + this.startDate);
          this.adjustStyle();
          header = "Wizard.step15.header";
          subheader = this.$t("Wizard.step15.subheader", { item: this.itemName.single });
          canContinue = true;
          break;

        case 17:
          header = "Wizard.step17.header";
          subheader = this.isAuthenticated
            ? `Wizard.step17.press_finish`
            : this.showSignIn
            ? "Wizard.step17.sign_in"
            : "Wizard.step17.details";
          canContinue = this.isValid || (this.showSignIn && this.validEmail && this.validPassword);
          showContinue = false;
          break;
        case 16:
          header = "Wizard.step16.header";
          subheader =
            this.divisions.length == 1
              ? this.$t("Wizard.step16.option_for") + this.divisions[0].name
              : this.$t("Wizard.step16.enter_option");
          subheader += this.$t("Wizard.step16.extra_option");
          canContinue = true;
          showContinue = true;
      }

      return {
        showSkip: showSkip,
        showContinue: showContinue,
        canContinue: canContinue,
        header: header,
        subheader: subheader,
      };
    },

    seasonDates() {
      if (this.startDate && this.endDate) {
        const date1 = new Date(this.startDate);
        const date2 = new Date(this.endDate);
        const diffTime = Math.abs(date2 - date1);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return {
          days: diffDays,
          weeks: Math.round(diffDays / 7),
        };
      }

      return {
        weeks: 0,
        days: 0,
      };
    },
  },
  watch: {
    reviewTimeslots: function(val) {
      console.log("RT: " + val);
      if (!val) {
        this.calendarOptions.events = this.getCalTimeslots();
      }
    },
    step: function() {
      if (this.step === 0) {
        console.log("0!");
      }
    },
  },
  methods: {
    newFinish(num) {
      console.log("Create league....");
      console.log("⭐️ CREATE THE LEAGUE ⭐️");
      this.map = null;
      api
        .finishWizard(this.$data)
        .then(response => {
          console.log("RESPONSE", response);
          this.setCurrentLeagueSeasonId(response.data.league.id, response.data.season.id);
          setTimeout(() => {
            if (num == 0) {
              this.goRouter("/schedules/new");
            } else {
              this.goRouter("/");
            }
          }, 1000);
        })
        .catch(e => {
          console.log("ERROR", e);
        })
        .finally(() => {
          console.log("Finally");
        });
    },
    getDayNames() {
      return arg => {
        var days = [
          this.$t("monday"),
          this.$t("tuesday"),
          this.$t("wednesday"),
          this.$t("thursday"),
          this.$t("friday"),
          this.$t("saturday"),
          this.$t("sunday"),
        ];
        if (this.calendarMode == 0) {
          days = [
            this.$t("sunday"),
            this.$t("monday"),
            this.$t("tuesday"),
            this.$t("wednesday"),
            this.$t("thursday"),
            this.$t("friday"),
            this.$t("saturday"),
          ];
        }

        var d = days[arg.date.getDay()];
        if (window.innerWidth < 1200) {
          return d.substring(0, 3);
        }
        return d;
      };
    },
    updateDays() {
      setTimeout(() => {
        this.width = window.innerWidth;
        this.calendarOptions.dayHeaderContent = this.getDayNames();
      }, 200);
    },
    doSignIn() {
      var e = localStorage.getItem("user_email");
      var url = "/sign-in?return=/wizard";
      if (e) {
        url += "&email=" + e;
      }
      console.log(url);
      this.goRouter(url);
    },
    configUpdate(d) {
      console.log("ConfigUpdate", d);
      var c = d.config;

      if (c.max_games_day > 0 && c.max_games_week > 0 && c.max_games_day > c.max_games_week) {
        console.log("DoMaxGamesDay");
        c.max_games_week = c.max_games_day;
      }

      if (c.max_games_week > 0 && c.max_games_day > c.max_games_week) {
        console.log("DoMaxGamesDay");
        c.max_games_day = c.max_games_week;
      }

      if (c.max_games_day == 1) {
        console.log("DoMinsRest");
        c.min_minutes_rest = 0;
      }

      if (c.max_games_day > 1) {
        console.log("DoMinsRest");
        c.next_game_offset = 0;
      }
    },
    hasConflict(slot) {
      var checks = this.timeslots.concat(this.existingTimeslots);
      var ss = this.$moment(new Date(slot.start));
      var se = this.$moment(new Date(slot.end));
      var conflict = false;
      checks.forEach(c => {
        if (c.surface_id == slot.surface_id) {
          var cs = this.$moment(new Date(c.start));
          var ce = this.$moment(new Date(c.end));
          if (ss.isBetween(cs, ce, "[]")) {
            console.log("🔴 Starts in middle of slot");
            conflict = true;
          } else if (se.isBetween(cs, ce, "[]")) {
            console.log("🔴 Ends in middle of slot");
            conflict = true;
          } else if (ss.isSame(cs)) {
            console.log("🔴 Start Same");
            conflict = true;
          } else if (se.isSame(ce)) {
            console.log("🔴 End Same");
            conflict = true;
          }
        }
      });
      return conflict;
    },
    storeData() {
      console.log("✅ StoreData");
      var x = {
        lastUpdate: new Date(),
        lengthOptions: this.lengthOptions,
        slotLength: this.slotLength,
        originals: [],
        allTeams: this.allTeams,
        isPractice: this.isPractice,
        someTeams: this.someTeams,
        seasonName: this.seasonName,
        furthestStep: this.furthestStep,
        template: this.template,
        timeslots: this.timeslots,
        totalTimeslotsNeeded: this.totalTimeslotsNeeded,
        userInfo: this.userInfo,
        style: this.style,
        styleCount: this.styleCount,
        gameLength: this.gameLength,
        teams: this.teams,
        surfaceCount: this.surfaceCount,
        venueIndex: this.venueIndex,
        trigger: this.trigger,
        step: this.step,
        divisions: this.divisions,
        venues: this.venues,
        sport: this.sport,
        leagueName: this.leagueName,
        divisionCount: this.divisionCount,
        teamCount: this.teamCount,
        venueCount: this.venueCOunt,
        startDate: this.startDate,
        endDate: this.endDate,
        applyStart: this.applyStart,
        applyEnd: this.applyEnd,
      };
      localStorage.setItem("wizard", JSON.stringify(x));
    },
    refresh() {
      var x = window.location.search;
      this.goRouter("/");
      setTimeout(() => {
        this.goRouter("/wizard" + x);
      }, 500);
    },
    clearSlots(all) {
      this.originals = [];
      if (all) {
        this.timeslots = [];
      }
      this.calendarOptions.events = this.getCalTimeslots();
    },
    doTemplate() {
      var n = this.potentialSlots.new;
      this.finalTimeslots = this.timeslots.concat(this.potentialSlots.newslots);
      this.finalTimeslots.sort(this.dynamicSort("start_timestamp"));
      this.timeslots = this.finalTimeslots;
      this.calendarOptions.events = this.getCalTimeslots();
      this.templateDialog = false;
      this.makeToast("success", this.$t("created") + n + this.$t("new-timeslots"));
      this.toggleCalendar(1);
      this.clearSlots(false);
      this.templateDialog = false;
      console.log("CalTimeslots", this.calendarOptions.events.length);
    },
    toggleCalendar(num) {
      console.log(this.startDate);
      this.calendar = this.$refs.fullCalendar;
      this.calendarOptions.scrollTime = "08:00:00";
      this.calendarOptions.scrollTimeReset = false;

      this.calendarMode = num;
      if (num == 0) {
        this.calendarDate = this.calendar.getApi().getDate();
        this.calendarView = this.calendar.getApi().view.type;
        this.calendar.getApi().changeView("timeGridWeek", this.startDate);
        this.calendarOptions.headerToolbar = {
          left: "",
          right: "",
          center: "",
        };
        this.calendarOptions.initialDate = this.startDate;
      } else {
        if (this.originals.length) {
          this.templateDialog = true;
          this.templateSource = 0;
        }
        this.calendarOptions.headerToolbar = {
          right: "today,prev,next",
          left: "title",
          center: "dayGridMonth,timeGridWeek,timeGridDay",
        };
        console.log("Change to " + this.calendarView + " at " + this.calendarDate);
        this.calendar.getApi().changeView(this.calendarView, this.calendarDate);
        this.calendarOptions.initialDate = this.calendarDate;
      }
      this.calendarOptions.events = this.getCalTimeslots();
    },
    getCalTimeslots() {
      if (this.calendarMode === 0) {
        return this.originals;
      } else {
        return this.timeslots.concat(this.existingEvents);
      }
    },
    startDeleteExisting() {
      var x = window.confirm(
        this.$t(
          "are-you-sure-this-will-permanently-delete-these-open-timeslots-from-your-season-no-games-will-be-deleted-this-is-not-reversible-click-ok-to-continue-or-cancel-to-cancel",
        ),
      );
      if (x) {
        console.log("Delete existing timeslots", this.existingTimeslots.length);
        var ids = [];
        this.existingTimeslots.forEach(t => {
          ids.push(t.id);
        });
        console.log(ids);
        api
          .bulkDeleteTimeslots({ ids: ids })
          .then(response => {
            console.log("Response", response);
            this.makeToast("success", this.$t("timeslots-deleted"));
            this.existingTimeslots = [];
            this.reviewTimeslots = false;
          })
          .catch(e => {
            console.log("Error", e);
          });
      }
    },
    setSport(name) {
      this.sport = name;
      this.next();
    },
    getExistingTimeslots() {
      if (!this.loggedIn) {
        return;
      }
      console.log("Get existing timeslots for " + this.division_id);
      api
        .getDivisionTimeslots(this.division_id, this.startDate, this.endDate)
        .then(response => {
          console.log("Set existing timeslots to ", response.data);
          this.existingTimeslots = response.data;
          console.log("New Existing Timeslots:", this.existingTimeslots);
        })
        .catch(e => {
          console.log("Error", e);
        });
    },
    remove(timeslot) {
      console.log(timeslot);
      var x = confirm(
        this.$t("are-you-sure-you-want-to-remove-this-timeslot") +
          timeslot.title +
          " " +
          timeslot.start_date +
          " at " +
          timeslot.start_time,
      );
      if (x) {
        this.finalTimeslots.splice(this.finalTimeslots.indexOf(timeslot), 1);
        this.makeToast("info", this.$t("deleted-timeslot"));
      }
    },
    removeRealID(timeslot_id) {
      console.log("remove real id...", timeslot_id);
      this.existingTimeslots.forEach(e => {
        if (e.id == timeslot_id) {
          console.log("Found");
          this.removeReal(e);
        }
      });
    },
    removeReal(timeslot) {
      if (!timeslot) {
        return;
      }
      var x = confirm(
        this.$t("are-you-sure-you-want-to-remove-this-timeslot") +
          (timeslot.start_date || timeslot.start) +
          " at " +
          timeslot.venue.name +
          " " +
          timeslot.surface.name +
          "?",
      );
      if (x) {
        api
          .deleteTimeslot(timeslot.id)
          .then(() => {
            this.existingTimeslots.splice(this.existingTimeslots.indexOf(timeslot), 1);
            this.makeToast("info", this.$t("deleted-timeslot"));
            this.activeEvent = false;
            this.calendarOptions.events = this.getCalTimeslots();
          })
          .catch(() => {
            this.makeToast("error", this.$t("Toast.error.delete_timeslot"));
          });
      }
    },
    openCSV() {
      if (!this.isAuthenticated) {
        this.goRouter("/sign-up?return=/import/csv");
      } else {
        this.goRouter("/leagues/new?return=/import/csv");
      }
    },
    doFinish(shouldSchedule) {
      this.shouldSchedule = shouldSchedule;
      if (!this.shouldSchedule) {
        this.divisions.forEach(d => {
          d.shouldSchedule = false;
        });
      }
      this.showDecision = false;
      this.finish();
    },
    confirmCancel() {
      this.storeData();
      this.refreshLeagueInformation("/leagues");
    },
    setLeagueName() {
      if (!this.isProduction) {
        this.sport = this.$t("soccer");
        this.leagueName = this.$t("AppMenu.league") + new Date().toLocaleDateString();
        this.seasonName = this.$t("szn") + new Date().toLocaleDateString();
      } else {
        this.leagueName = "";
        this.seasonName = "";
      }
    },
    getTimeslotColor(division_ids) {
      if (!division_ids.length) {
        return "black";
      } else if (division_ids.length == 1) {
        return this.getDivisionColor(division_ids[0]);
      } else {
        return "grey";
      }
    },
    back() {
      if (this.reviewTimeslots) {
        this.reviewTimeslots = false;
        return;
      }
      this.step--;
      console.log("Back: " + this.step);
      if (this.step == 3) {
        this.step = 2;
      } else if ((this.step == 10 || this.step == 6) && this.division_id) {
        console.log("Back...div");
        this.refreshLeagueInformation("/");
      } else if (this.step == 7) {
        this.doMap();
      }
    },
    disableTooltip(t) {
      if (this.noTooltip) {
        return;
      }
      this.noTooltip = true;
      setTimeout(() => {
        this.noTooltip = false;
      }, t);
    },
    finishTimeslots() {
      this.showWarningDialog = false;
      this.next();
      console.log("End Timeslots Length: " + this.finalTimeslots.length);
    },
    mouseMove() {
      if (!this.showTooltip) {
        this.tooltipPosition = {
          position: "fixed",
          zIndex: 2,
          top: "0px",
          left: "0px",
          width: "200",
          height: "auto",
          background: "white",
          padding: "20px",
          borderRadius: "5px",
          border: "1px solid rgba(0,0,0,0.55)",
          boxShadow: "box-shadow: 0 1px 2px rgba(0,0,0,0.15)",
        };
      }
    },
    eventMouseEnter(e) {
      var el = e.jsEvent.target;
      var count = 0;
      while (count < 5 && !el.classList.contains("fc-timegrid-event-harness")) {
        el = el.parentElement;
        count++;
      }
      const rect = el.getBoundingClientRect();
      var x = rect.left + window.scrollX;
      var y = rect.bottom + window.scrollY;
      this.tooltipPosition.left = x + "px";
      this.tooltipPosition.top = y + "px";

      if (this.noTooltip) {
        return;
      }
      this.tooltipString =
        e.event.title +
        "<br><small>" +
        this.$moment(e.event.start).format("LLLL") +
        " - " +
        this.$moment(e.event.end).format("hh:mm a") +
        " </small>";
      this.showTooltip = true;
    },
    eventMouseLeave() {
      this.showTooltip = false;
    },
    getProgressColor(have, need) {
      var color = "#8b0000";
      if (have >= need) {
        color = "#006400";
      } else if (have / need >= 0.5) {
        color = "black";
      }
      return { color: color };
    },
    setVenue(venue) {
      this.template.venue = venue;
      this.template.surface_ids = [venue.surfaces[0]];
      this.template.division_ids = [];
      this.divisions.forEach(d => {
        this.template.division_ids.push(d.id);
      });
    },
    getDivisionColor(id) {
      var color = "grey";
      this.divisions.forEach(d => {
        if (d.id == id) {
          color = d.color;
        }
      });
      return color;
    },
    handleEventClick(clickInfo) {
      this.eventMouseLeave();
      var e = clickInfo.event;
      this.activeEvent = e;
    },
    duplicateFakeslot(e) {
      this.originals.forEach((t, i) => {
        if (t.id == e.id) {
          var y = Object.assign({}, t);
          y.id = this.getRandomId();
          this.originals.push(y);
          this.makeToast("success", this.$t("timeslot-duplicated"), null, 1000);
          this.calendarOptions.events = this.getCalTimeslots();
          this.activeEvent = null;
        }
      });
    },
    deleteFakeslot(e) {
      this.originals.forEach((t, i) => {
        if (t.id == e.id) {
          this.originals.splice(i, 1);
          this.makeToast("info", this.$t("timeslot-deleted"), null, 1000);
          this.calendarOptions.events = this.getCalTimeslots();
        }
      });
      this.activeEvent = null;
    },

    handleEventDrop(eventDropInfo) {
      this.disableTooltip(1500);
      this.eventMouseLeave();
      var e = eventDropInfo.event;
      this.originals.forEach((t, i) => {
        if (t.id == e.id) {
          var begin = eventDropInfo.event.start;
          var finish = eventDropInfo.event.end;
          t.start = eventDropInfo.event.start;
          t.end = eventDropInfo.event.end;
          t.start_date = this.$moment(begin).format("MM-DD-YY");
          t.start_time = this.$moment(begin).format("LT");
          t.end_time = this.$moment(finish).format("LT");
          t.weekday = this.$moment(begin).format("dddd");
          t.start_timestamp = new Date(begin).getTime();
          console.log("✅ Updated Timeslot", t);
        }
      });
      this.calendarOptions.events = this.getCalTimeslots();
    },
    handleDateClick(dateInfo) {
      this.eventMouseLeave();
      if (this.calendarMode == 1 && dateInfo.view.type == "dayGridMonth") {
        this.calendar.getApi().changeView("timeGridWeek", dateInfo.date);
        return;
      }
      if (!this.template.venue) {
        this.makeToast("info", this.$t("select-a-venue-first"));
        return;
      }
      if (!this.template.surface_ids.length) {
        this.makeToast("info", this.$t("select-a-surface-first"));
        return;
      }
      if (this.template.venue) {
        var v = this.template.venue;
        var x = this.$moment(dateInfo.date);
        x.add(this.template.hours, "hours");
        x.add(this.gameLength, "minutes");
        this.template.finish = x._d;
        var begin = x._i;
        var finish = x._d;
        console.log("----");
        this.template.surface_ids.forEach(s => {
          var color = this.getTimeslotColor(this.template.division_ids);
          var x = {
            id: this.getRandomId(),
            venue_id: this.template.venue.id,
            textColor: this.invertColor(color),
            title: s.name + "@" + v.name,
            backgroundColor: color,
            borderColor: color,
            start: begin,
            end: finish,
            divisions: this.template.division_ids || [],
            surface_id: s.id,
            surface_name: s.name,
            venue_name: this.template.venue.name,
            start_date: this.$moment(begin).format("MM-DD-YY"),
            start_time: this.$moment(begin).format("LT"),
            end_time: this.$moment(finish).format("LT"),
            weekday: this.$moment(begin).format("dddd"),
            start_timestamp: new Date(begin).getTime(),
          };
          if (this.calendarMode === 1) {
            this.timeslots.push(x);
          } else {
            this.originals.push(x);
          }
        });
        if (this.template.surface_ids.length === 1) {
          this.disableTooltip(1500);
        }
        this.eventMouseLeave();
        this.calendarOptions.scrollTime = null;
        this.calendarOptions.events = this.getCalTimeslots();
      }
    },
    continueWithoutTimeslots() {
      this.templateDialog = false;
      if (this.templateSource === 1) {
        if (this.timeslotsGood) {
          this.finishTimeslots();
        } else {
          this.showWarningDialog = true;
          return;
        }
      }
    },
    slotsAvailable(id) {
      if (!this.divisions) {
        return 0;
      }
      if (!id) {
        return this.potentialSlots.existing + this.potentialSlots.pending;
      }
      var count = 0;
      var z = this.timeslots.concat(this.potentialSlots.pendingSlots);
      z.forEach(t => {
        if (!t.divisions || !t.divisions.length) {
          count += 1 / this.divisions.length;
        }
        if (t.divisions && t.divisions.indexOf(id) > -1) {
          count += 1 / t.divisions.length;
        }
      });
      return count.toFixed(1);
    },
    getDivision(id) {
      var div = null;
      this.divisions.forEach(d => {
        if (id == d.id) {
          div = d;
        }
      });
      return div;
    },
    adjustStyle(increase, division_id) {
      var div = null;
      if (division_id) {
        div = this.getDivision(division_id);
      }

      if (div && increase !== undefined) {
        if (increase) {
          div.styleCount++;
        } else {
          div.styleCount--;
        }
      }

      this.updateTimeslotCounts();
      if (!this.template.venue) {
        this.setVenue(this.venues[0]);
      }
      this.template.venue = this.template.venue || this.venues[0];
      if (this.template.venue) {
        this.template.surface_ids = [this.template.venue.surfaces[0]];
      }
    },
    updateTimeslotCounts() {
      var total = 0;
      var w = this.seasonDates.weeks;
      this.divisions.forEach(d => {
        var t = d.teams.length;
        var c = d.styleCount;

        // 4 teams
        switch (this.style) {
          // Select Sport
          case "rounds":
            // 5 rounds
            // 5 * 4 teams * 3 teams / 2
            d.slotsNeeded = (c * (t * (t - 1))) / 2;
            break;
          case "season":
            // 5 per team per season
            // 5 * 4 teams / 2
            d.slotsNeeded = (c * t) / 2;
            break;
          case "week":
            // 5 per team per week
            // 5 * 4 teams * numWeeks / 2
            d.config.max_games_week = c;
            var z = (c * t * w) / 2;
            console.log("Weeks --> ", c, t, w, z);
            d.slotsNeeded = z;
            break;
          case "games":
            // 5 games per season
            // 5 / 4 teams
            d.slotsNeeded = Math.ceil(c / t);
            break;
        }

        d.slotsNeeded = Math.max(1, Math.ceil(d.slotsNeeded));
        if (this.isPractice) {
          d.slotsNeeded = d.slotsNeeded * 2;
        }
        total += d.slotsNeeded;
      });
      console.log("Done total " + total);
      this.totalTimeslotsNeeded = total;
    },
    setStartDate(val) {
      this.startDate = val;
      this.applyStart = this.$moment(this.startDate).format("YYYY-MM-DD");
      return;
    },
    setEndDate(val) {
      this.endDate = val;
      this.applyEnd = this.$moment(this.endDate).format("YYYY-MM-DD");
      return;
    },
    signIn() {
      console.log("✅ Sign In");
      this.busy = true;
      this.$store
        .dispatch("signIn", {
          email: this.userInfo.email,
          password: this.userInfo.password,
        })
        .then(() => {
          localStorage.setItem("user_id", this.userInfo.id);
          localStorage.setItem("locale", this.userInfo.locale);
          this.busy = false;
          this.finish();
        })
        .catch(() => {
          this.isLoading = false;
          setTimeout(() => {
            alert(this.$t("we-cant-find-an-account-with-that-email-and-password-combination"));
            this.busy = false;
          }, 250);
        });
    },
    signUp() {
      this.busy = true;
      const user = {
        email: this.email.toLowerCase(),
        password: (Math.random() + 1).toString(36).substring(2),
        locale: this.$i18n.locale,
      };
      api
        .createTempUser(user)
        .then(response => {
          this.$store
            .dispatch("signIn", {
              email: user.email,
              password: user.password,
            })
            .then(() => {
              localStorage.setItem("user_id", response.data.id);
              localStorage.setItem("user_email", user.email);
              this.busy = false;
              this.newUser = false;
            });
        })
        .catch(error => {
          this.makeToast("error", this.$t("something-went-wrong"));
          console.error(error);
        });
    },
    setStyle(style) {
      this.style = style;
      this.timeslots = [];
      this.next();
    },
    resetVenue() {
      this.currentVenue.gaddress = null;
      this.currentVenue.address = {};
    },
    addAnotherVenue() {
      console.log("Another");
      this.venues.push({
        id: this.getRandomId(),
        gaddress: null,
        address: {},
      });
      this.venueIndex++;
      this.step = 7;
    },
    toggleTeams(division) {
      console.log(this.someTeams);
      var includes = false;
      division.teams.forEach(t => {
        console.log(t.id);
        if (this.someTeams.indexOf(t.id) > -1) {
          includes = true;
        }
      });

      if (includes) {
        console.log("Includes...remove all!");
        division.teams.forEach(dt => {
          this.someTeams.forEach(t => {
            if (t === dt.id) {
              this.someTeams.splice(this.someTeams.indexOf(t), 1);
            }
          });
        });
      } else {
        division.teams.forEach(t => {
          this.someTeams.push(t.id);
        });
      }
    },
    tryNext() {
      if (this.stepData.canContinue) {
        this.next();
      } else {
        console.log("TN");
      }
    },
    next() {
      this.manualVenue = false;
      this.showWarningDialog = false;
      this.reviewTimeslots = false;
      if (this.step === 1) {
        this.setLeagueName();
        setTimeout(() => {
          this.focusInput("leaguename");
        }, 200);
      }
      if (this.step === 2) {
        this.step = 4;
        return;
      } else if (this.step === 7) {
        setTimeout(() => {
          var x = this.$refs.address;
          if (x) {
            x.focus();
          }
        }, 250);
      } else if (this.step === 9) {
        this.currentVenue.teams = this.someTeams;
      } else if (this.step === 13) {
        this.getExistingTimeslots();
      } else if (this.step === 14) {
        this.calendarDate = this.startDate;
        this.timeslots = [];
        this.calendar = this.$refs.fullCalendar;
        this.calendarOptions.events = this.getCalTimeslots();
        this.updateTimeslotCounts();
        this.updateDays();
      }
      this.step = this.step + 1;
      if (this.step > this.furthestStep) {
        this.furthestStep = this.step;
      }
      if (this.step == 16 && !this.timeslots.length && !this.existingTimeslots.length) {
        this.divisions.forEach(d => {
          d.shouldSchedule = false;
        });
        this.shouldSchedule = false;
        this.next();
      }
      if (this.step > 15) {
        this.storeData();
      }
    },
    finish() {
      if (!this.isAuthenticated) {
        console.log("⭐️ NOT AUTHENTICATED ⭐️");
        if (this.showSignIn) {
          this.signIn();
        } else if (this.step !== 11) {
          this.goRouter("/sign-up");
        }
      }
    },
    setTeams(d, count) {
      this.divisions[d].teamCount = count;
      var i = 1;
      var teams = [];
      while (i <= count) {
        console.log(i, d);
        var z = i.toString() + this.getCharacter(d + 1);
        console.log("Set teams..." + "Team " + z, "Shortcode: " + "T" + z);
        teams.push({
          id: this.getRandomId(),
          name: this.$t("GameTable.column.team") + z,
          shortcode: "T" + z,
        });
        i++;
      }
      this.divisions[d].teams = teams;
    },
    getCharacter(i) {
      var str = "ABCDEFGHJKLMNOPQRSTUVQXYZ";
      return str.charAt(i - 1);
    },
    getAddressData: function(addressData, placeResultData, id) {
      console.log("GET ADDRESS DATA", addressData);
      var venue = this.venues[this.venueIndex];
      venue.gaddress = addressData;
      venue.address.formatted = placeResultData.formatted_address;
      venue.address.line_1 = ((venue.gaddress.street_number || "") + " " + venue.gaddress.route).trim();
      venue.address.city = venue.gaddress.locality;
      venue.address.state = venue.gaddress.administrative_area_level_1;
      venue.address.zip = venue.gaddress.postal_code;
      venue.address.country = venue.gaddress.country;
      venue.address.latitude = venue.gaddress.latitude;
      venue.address.longitude = venue.gaddress.longitude;
      venue.address.phone_primary = placeResultData.formatted_phone_number;
      venue.name = placeResultData.name;
      venue.address.link = placeResultData.url;
      venue.teams = [];
      venue.id = venue.id || this.getRandomId();
      venue.surfaces = [
        {
          id: this.getRandomId(),
          name: this.capitalizeFirstLetter(this.surfaceName.single) + " " + 1,
          teams: [],
        },
        {
          id: this.getRandomId(),
          name: this.capitalizeFirstLetter(this.surfaceName.single) + " " + 2,
          teams: [],
        },
      ];
      this.venues[this.venueIndex] = venue;
      console.log(this.venues[this.venueIndex]);
      this.trigger++;

      this.doMap();
    },
    doMap() {
      if (this.currentVenue.address && this.currentVenue.address.latitude && this.currentVenue.address.longitude) {
        setTimeout(() => {
          console.log("Creating map", [this.currentVenue.address.latitude, this.currentVenue.address.longitude]);
          if (this.map) {
            this.map.remove();
          }
          this.map = L.map("map").setView(
            [this.currentVenue.address.latitude, this.currentVenue.address.longitude],
            15,
          );
          var marker = L.marker([this.currentVenue.address.latitude, this.currentVenue.address.longitude]).addTo(
            this.map,
          );
          var popup = this.$t(
            "less-than-b-greater-than-this-currentvenue-name-less-than-b-greater-than-less-than-br-greater-than-this-currentvenue-address-formatted-less-than-br-greater-than-this-currentvenue-notes-or-or",
            [this.currentVenue.name, this.currentVenue.address.formatted, this.currentVenue.notes || ""],
          );
          marker.bindPopup(popup).openPopup();
          L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
          }).addTo(this.map);
        }, 250);
      }
    },
    getRandomId() {
      var crypto = require("crypto");
      return crypto.randomBytes(20).toString("hex");
    },
    setDivisions(val) {
      console.log("SetDivisions");
      if (val) {
        this.divisionCount = val;
      }
      var i = 1;
      this.divisions = [];
      while (i <= this.divisionCount) {
        this.divisions.push({
          id: this.getRandomId(),
          name: this.$t("Division_with_num", { num: i }),
          shortcode: "D" + i,
          styleCount: 2,
          shouldSchedule: true,
          showColor: false,
          config: {
            min_minutes_rest: 0,
            next_game_offset: 0,
            max_games_day: 1,
            max_games_week: 0,
          },
          teamCount: 4,
          slotsNeeded: 0,
          slotsAvailable: 0,
          color: this.randomSecondaryHex(i),
          teams: [
            {
              id: this.getRandomId(),
              name: this.$t("Team_with_num", { num: "1" + this.getCharacter(i) }),
              shortcode: "T1" + this.getCharacter(i),
            },
            {
              id: this.getRandomId(),
              name: this.$t("Team_with_num", { num: "2" + this.getCharacter(i) }),
              shortcode: "T2" + this.getCharacter(i),
            },
            {
              id: this.getRandomId(),
              name: this.$t("Team_with_num", { num: "3" + this.getCharacter(i) }),
              shortcode: "T3" + this.getCharacter(i),
            },
            {
              id: this.getRandomId(),
              name: this.$t("Team_with_num", { num: "4" + this.getCharacter(i) }),
              shortcode: "T4" + this.getCharacter(i),
            },
          ],
        });
        i++;
      }
    },
    setFields(count) {
      if (count) {
        this.surfaceCount = count;
      }
      console.log("SetFields: " + this.surfaceCount);
      var i = 0;
      if (this.currentVenue.surfaces && this.currentVenue.surfaces.length > this.surfaceCount) {
        this.currentVenue.surfaces = this.currentVenue.surfaces.slice(0, this.surfaceCount);
        return;
      }
      while (i < this.surfaceCount) {
        if (!this.currentVenue.surfaces || !this.currentVenue.surfaces[i]) {
          this.currentVenue.surfaces = this.currentVenue.surfaces || [];
          this.currentVenue.surfaces.push({
            id: this.getRandomId(),
            name: `${this.capitalizeFirstLetter(this.surfaceName.single)} ` + (i + 1),
            color: this.randomSecondaryHex(i),
            teams: [],
          });
        }
        i++;
      }
    },
  },
  mounted() {
    this.width = window.innerWidth;
    window.addEventListener("resize", this.updateDays);
    if (window.location.href.includes("localhost")) {
      this.userInfo.first = this.$t("first") + new Date().getTime();
      this.userInfo.last = this.$t("last") + new Date().getTime();
      this.userInfo.email = "email" + new Date().getTime() + "@test.com";
      this.userInfo.organization = this.$t("AppMenu.organization") + new Date().getTime();
      this.userInfo.password = "password";
    }

    if (this.currentUser) {
      this.newUser = false;
    }

    const email = this.$route.query.email;
    const token = this.$route.query.token;
    if (email && token) {
      this.newUser = false;
      this.$store
        .dispatch("signIn", {
          email: email.toLowerCase(),
          password: token,
        })
        .then(() => {
          this.$store.dispatch("getLeagueInformation");
          this.makeToast("success", this.$t("Toast.welcome"));
        });
    }

    if (!this.loggedIn && this.getCookie("dsuid")) {
      console.log("Should prompt!");
      this.signInPrompt = true;
    }
    window.lastRoute = "/wizard";
    window.addEventListener("mousedown", e => {
      this.showTooltip = false;
    });
    if (window.location.href.split("sport=")[1]) {
      this.setSport(this.getSportFromID(window.location.href.split("sport=")[1]));
    } else if (this.currentLeague) {
    }
    this.trackEvent("Opened Wizard", { division_id: this.division_id });
    window.analytics.page();
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = function() {
      if (window.location.href.includes("/wizard")) {
        if (this.step > 0) {
          alert(this.$t("use-the-big-red-back-button-go-back-or-press-save-to-finish"));
          window.history.pushState(null, "", window.location.href);
        }
      }
    };

    if (window.location.href.split("division_id=")[1]) {
      this.division_id = window.location.href.split("division_id=")[1];
      this.$store.getters.currentSeason.divisions.forEach(d => {
        if (d.id == this.division_id) {
          var x = Object.assign({}, d);
          x.styleCount = 2;
          x.shouldSchedule = true;
          x.config = {
            min_minutes_rest: 0,
            next_game_offset: 0,
            max_games_day: 1,
            max_games_week: 0,
          };
          this.divisions = [x];
          this.template.division_ids = [x.id];
        }
      });

      if (!this.$store.getters.currentSeason.venues.length) {
        this.step = 7;
      } else {
        this.venues = this.$store.getters.currentSeason.venues;
        this.surfaces = [];
        this.venues.forEach(v => {
          v.surfaces.forEach(s => {
            this.surfaces.push(s);
          });
        });
        this.step = 11;
      }
      this.busy = false;
    } else {
      this.busy = false;
    }
    window.onmousemove = e => {
      this.mouseMove(e);
    };
  },
  created() {
    if (!window.location.href.split("step=")[1]) {
      return;
    }
    this.sport = this.$t("soccer");
    this.leagueName = this.$t("my-league");
    this.startDate = this.startDate || new Date();
    this.endDate =
      this.endDate ||
      this.$moment(this.startDate)
        .add(12, "weeks")
        .format("YYYY-MM-DD");

    this.venues[0] = {
      id: "ferfttrefrefre",
      name: this.$t("flutie-athletic-complex"),
      address: {
        city: "Melbourne",
        country: "United States",
        formatted: "150 W University Blvd, Melbourne, FL 32901, USA",
        latitude: 28.0646888,
        line_1: "ウェスト・ユニバーシティ・ブルバード150",
        link: "https://maps.google.com/?cid=4015618102034841365",
        longitude: -80.62302199999999,
        phone_primary: "(321) 674-8000",
        state: "FL",
        zip: "32901",
      },
      color: "green",
      teams: [],
      surfaces: [
        {
          id: "CCacd8892e8cec39dfa66306f7032c7cb8973de426",
          name: this.$t("majors-field"),
          teams: [],
          color: this.randomSecondaryHex(0),
        },
        {
          id: "XX1c9980e14108d92b274ef9b2964d8420964de40a",
          name: this.$t("minors-field"),
          teams: [],
          color: this.randomSecondaryHex(1),
        },
      ],
    };
    this.venues[1] = {
      id: "efrfefrefe",
      name: this.$t("hoover-middle-school"),
      address: {
        city: "Melbourne",
        country: "United States",
        formatted: "150 W University Blvd, Melbourne, FL 32901, USA",
        latitude: 28.0646888,
        line_1: "ウェスト・ユニバーシティ・ブルバード150",
        link: "https://maps.google.com/?cid=4015618102034841365",
        longitude: -80.62302199999999,
        phone_primary: "(321) 674-8000",
        state: "FL",
        zip: "32901",
      },
      color: "red",
      teams: [],
      surfaces: [
        {
          id: "Bacd8892e8cecrefa66306f7032c7cb8973de426",
          name: "Court 1",
          teams: [],
          color: this.randomSecondaryHex(0),
        },
        {
          id: "C1c9980e1410re92b274ef9b2964d8420964de40a",
          name: "Court 2",
          teams: [],
          color: this.randomSecondaryHex(1),
        },
      ],
    };
    setTimeout(() => {
      this.step = parseInt(window.location.href.split("step=")[1] || 12);
    }, 100);
    this.adjustStyle();
    return;
  },
};
</script>

<style lang="scss">
.fc-col-header-cell {
  .fc-scrollgrid-sync-inner {
    text-align: center;
  }
  .fc-col-header-cell-cushion {
    height: 2em;
    line-height: 2em;
    margin: 0 auto;
    text-align: center;
    overflow: hidden;
    text-overflow: clip;
  }
}
.asd__day-today {
  border: 2px solid orange;
}
.asd__day--old {
  /* filter: brightness(0.1); */
  background: rgba(0, 0, 0, 0.05) !important;
}

.datePicker {
  div {
    text-align: center;
  }
  input {
    text-align: center;
    font-size: 1.5em;
    font-family: inherit;
    border-color: rgba(0, 0, 0, 0.5);
    border-radius: 5px;
    color: inherit;
    padding: 5px;
    margin: 0 auto;
  }
}

.timeslotLength {
  input {
    font-size: 1em !important;
    min-height: 1em !important;
  }
}

.asd__wrapper {
  margin: 0 auto;
}
</style>
<style scoped lang="scss">
.p-inputtext {
  min-height: unset !important;
}

.leagueBox {
  font-size: 1.5em !important;
  padding: 15px 20px !important;
  width: 100%;
}
.p-button.p-button-sm {
  min-width: 30px !important;
  min-height: 30px !important;
}

.slotLengthOption {
  display: inline;
}

.templateWrapper {
  padding: 20px 5px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  background: rgba(0, 0, 0, 0.01);
  border-radius: 5px;
}
.timeslotRow {
  .p-text-left {
    width: 75%;
  }
}

.bigWhiteButton {
  width: 95%;
  min-width: 150px;
  margin: 0 auto;
  padding: 30px 10px;
  border-style: solid;
  border-width: 2px;
  border-color: rgba(0, 148, 255, 0.4);
  border-radius: 10px;
  text-align: center;
  background: white;
  box-shadow: 4px 4px 0 0 rgba(0, 148, 255, 0.4);
  font-size: 1.5em;
  cursor: pointer;

  img {
    height: 80px;
    margin-bottom: 10px;
  }
}
.wizardLabel {
  font-size: 1.25em;
  font-weight: bold;
  margin: 5px auto;
}
#map {
  width: 100%;
  height: 200px;
}

table {
  width: 100%;
  padding: 10px;
}

.menuEntryColor {
  margin-left: 3px;
}
.timeslotRow {
  border-bottom: 1px solid rgba(0, 0, 0, 0.4);
  td {
    padding: 8px 0px;
  }
}

.bigButton {
  height: 200px;
  max-width: 30vw;
  max-height: 30vw;
  width: 312px;
  border-radius: 8px;
  font-size: 1.5em;
  line-height: 1.1em;
  font-weight: 700;
}
.header {
  font-size: 40px;
  line-height: 44px;
  font-weight: bold;
}

.subheader {
  font-size: 20px;
  line-height: 32px;
  margin: 15px auto;
}
hr {
  margin: 3px 0;
}
</style>
